<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Equipment Servicing Schedule'|translate }}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>
                    <v-btn class="accent mr-2" @click="editedItem=null;dialog=true"
                           :disabled="!$can('update', 'EquipmentServicingSchedule')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <equipment-servicing-schedule-dialog v-model="dialog" :item="editedItem"
                                                         v-on:doreload="refresh()"></equipment-servicing-schedule-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="ess"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.desc }}</td>
                            <td>{{ props.item.equipment_name }}</td>
                            <td>{{ props.item.floor_name }}</td>
                            <td>{{ props.item.start_date }}</td>
                            <td>{{ props.item.end_date }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'EquipmentServicingSchedule')"
                                    @click="$can('update', 'EquipmentServicingSchedule') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'EquipmentServicingSchedule')"
                                    @click="$can('update', 'EquipmentServicingSchedule') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getEquipmentServicingSchedule, deleteEquipmentServicingSchedule} from '../helper'
import EquipmentServicingScheduleDialog from "../components/EquipmentServicingScheduleDialog";

export default {
    name: 'EquipmentServicingSchedule',
    components: {EquipmentServicingScheduleDialog},
    data() {
        return {
            dialog: false,
            headers: [
                {text: this.$options.filters.translate('Name'), value: 'name'},
                {text: this.$options.filters.translate('Description'), value: 'desc'},
                {text: this.$options.filters.translate('Equipment name'), value: 'equipment_name'},
                {text: this.$options.filters.translate('Floor name'), value: 'floor_name'},
                {text: this.$options.filters.translate('Start date'), value: 'start_date'},
                {text: this.$options.filters.translate('End date'), value: 'end_date'},
            ],
            ess: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },

    mounted() {
        this.initialize()
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    methods: {
        initialize() {
            this.refresh()
        },

        editItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteEquipmentServicingSchedule({
                    'ess_id': item.ess_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getEquipmentServicingSchedule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.ess = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
